export default __webpack_public_path__ + "static/media/adv.99519723.png";